import React, { useState } from "react";
import axios from "axios";

export const useStripePayment = (data) => {
    const [publicKey, setPublicKey] = useState()
    const [clientSecret, setClientSecret] = useState()
    const [stripeBuffer, setStripeBuffer] = useState(false)
    const [error, setError] = useState()
    const [stripeModalShow, setStripeModalShow] = useState(false)

    const stripeMakePayment = () => {
        setStripeBuffer(true)
        axios.post("/api/stripe-payment-make", data).then(async (res) => {
            setStripeBuffer(false)
            setPublicKey(res.data.public_key)
            setClientSecret(res.data.clientSecret)

            localStorage.setItem('cliSec',res.data.clientSecret);
            setStripeModalShow(true)
        }).catch(err => {
            
            setError(err);
        });


    }

    return { stripeMakePayment, stripeBuffer, clientSecret, publicKey, error, stripeModalShow, setStripeModalShow }
}
//have pass object like this
// let data = {
//     amount: props?.fee,
//     event_type: props?.event_type,
//     event_id: props?.event_id
//   };
